import capitalize from 'lodash-es/capitalize';
import {
    DID_YOU_KNOW,
    FORUMS_ACCUSATIVE,
    HINT_FOR_FORUMS,
    NEWEST_DISCUSSIONS,
    SHORTENED_ORDER_BY,
    SHORTENED_SEARCH_IN_FORUM,
    WHERE_ARE_DISCUSSIONS,
} from 'mk/autogenerated/translations/ForumFeed.f225b1b075aad87362f653035bc24e1f'
import Feed from 'mk2/apps/forum/components/Feed';
import { READ_FEED_TIMEOUT } from 'mk2/apps/forum/constants';
import { FORUM_FEED_MENU_ORDERBY } from 'mk2/apps/forum/containers/ForumFeed/ForumFeed.constants';
import { ORDER_BY_NEWEST, ORDER_BY_UPDATED, OrderBy } from 'mk2/apps/forum/containers/ForumFeed/ForumFeed.reducers';
import { Props } from 'mk2/apps/forum/containers/ForumFeed/ForumFeedPage';
import { PostEntity } from 'mk2/apps/forum/schemas';
import { forumFeedNewestUrl, forumFeedUpdatedUrl, forumSearchUrl } from 'mk2/apps/forum/urls';
import AnnouncementBox, { BoxType } from 'mk2/components/AnnouncementBox';
import Btn, { BtnLayout, BtnType } from 'mk2/components/Btn';
import Interpolate from 'mk2/components/Interpolate';
import MenuItem from 'mk2/components/menu/MenuItem';
import Menu from 'mk2/containers/Menu/Menu';
import React from 'react';
import styles from './ForumFeed.mscss';

class ForumFeed extends React.PureComponent<Props> {

    private readTimer: number;

    public componentDidMount() {
        if (this.props.unreadCount) {
            this.readTimer = window.setTimeout(this.props.onRead, READ_FEED_TIMEOUT);
        }
    }

    public componentDidUpdate(prevProps: Props) {
        if (this.props.unreadCount) {
            window.clearTimeout(this.readTimer);
            this.readTimer = window.setTimeout(this.props.onRead, READ_FEED_TIMEOUT);
        }
    }

    public componentWillUnmount() {
        window.clearTimeout(this.readTimer);
    }

    public render() {
        const { onCloseHint, onForumFeedMenuOrderBy, orderBy, showHint } = this.props;

        return (
            <div>
                {showHint && (
                    <AnnouncementBox
                        type={BoxType.Yellow}
                        hasDetailMessage
                        message={DID_YOU_KNOW}
                        detailMessage={(
                            <Interpolate
                                i18nKey={HINT_FOR_FORUMS}
                                FORUMS={(
                                    <>
                                        <b>{capitalize(FORUMS_ACCUSATIVE)}</b>
                                    </>
                                )}
                            />
                        )}
                        onClose={onCloseHint}
                    />
                )}

                <div className={styles.ForumFeed__orderAndSearch}>
                    <div className={styles.ForumFeed__orderAndSearch__orderBy}>
                        <span className={styles.ForumFeed__orderAndSearch__orderBy__label}>{SHORTENED_ORDER_BY}:</span>
                        <Menu
                            menuId={FORUM_FEED_MENU_ORDERBY}
                            trigger={(
                                <Btn
                                    type={BtnType.GreyText}
                                    icon="fa-chevron-down"
                                    label={orderBy === ORDER_BY_UPDATED ? WHERE_ARE_DISCUSSIONS : NEWEST_DISCUSSIONS}
                                    layout={BtnLayout.LabelIcon}
                                    onClick={onForumFeedMenuOrderBy}
                                />
                            )}
                            triggerShadow={false}
                        >
                            <MenuItem
                                label={NEWEST_DISCUSSIONS}
                                onClick={this.handleOrderByNewest}
                            />
                            <MenuItem
                                label={WHERE_ARE_DISCUSSIONS}
                                onClick={this.handleOrderByUpdated}
                            />
                        </Menu>
                    </div>

                    <Btn
                        className={styles.ForumFeed__orderAndSearch__search}
                        classNames={{
                            icon: styles.ForumFeed__orderAndSearch__search__icon,
                            label: styles.ForumFeed__orderAndSearch__search__label,
                        }}
                        layout={BtnLayout.IconLabel}
                        icon="fa-search"
                        link={forumSearchUrl}
                        label={SHORTENED_SEARCH_IN_FORUM}
                    />
                </div>

                <Feed
                    {...this.props}
                    onLoad={this.handleLoad}
                    onPostTopicClickedStoreEvent={this.onPostTopicClickedStoreEvent}
                    showNewBadge={orderBy === ORDER_BY_UPDATED}
                    showTopic
                    showCreated={false}
                    readonlyPosts={false}
                    inFeed
                />
            </div>
        );
    }

    private handleLoad = (after?: number) => {
        const { onLoad, orderBy } = this.props;
        onLoad(orderBy, after);
    };

    private handleOrderByNewest = () => {
        this.handleOrderBy(ORDER_BY_NEWEST);
    };

    private handleOrderByUpdated = () => {
        this.handleOrderBy(ORDER_BY_UPDATED);
    };

    private handleOrderBy = (orderBy: OrderBy) => {
        if (this.props.orderBy === orderBy) {
            return;
        }

        this.props.history.replace({
            pathname: orderBy === ORDER_BY_UPDATED ? forumFeedUpdatedUrl : forumFeedNewestUrl,
        });
    };

    private onPostTopicClickedStoreEvent = (post: PostEntity) => {
        const { onStoreEvent } = this.props;
        onStoreEvent('forum_category_clicked', {
            slug: post.topic.slug,
            from: 'updated',
        });
    };
}

export default ForumFeed;
